export const demiurge = [
	{
		"id": 1,
		"jump": "demi1",
		"title": "Demiurge: Flight",
		"pic": "../img/demiurge/demiurge-flight.jpg",
		"alt": "Demiurge, Flight - Digital Art",
		"left": "imagewide",
		"right": "slim"
	},
	{
		"id": 2,
		"jump": "demi2",
		"title": "Demiurge: Satellite",
		"pic": "../img/demiurge/demiurge-satellite.jpg",
		"alt": "Demiurge, Satellite - Digital Art",
		"left": "imagewide",
		"right": "slim"
	},
]